module.exports = __webpack_public_path__ + "0acdd31fcbe7ea964cddcc8096ce2c3d.pdf";